import {
  ApprovedIcon,
  LikeIcon,
  Regularize,
  RejectIcon,
} from "../../../assets/images";
import BoxLoader from "../../commons/BoxLoader/BoxLoader";
import CustomizedAvatar from "../../commons/CircularAvatar/CustomizedAvatar";
import "../ThinksToDo.scss";
type AppProps = {
  handleFeedBackModal: (data: any) => void;
  data: any;
  fetching: boolean;
};
const RegularizeApproveAndReject = ({
  handleFeedBackModal,
  data,
  fetching,
}: AppProps) => {
  return (
    <div
      className="boxs scheduled-upcoming-interviews"
      style={{ overflow: "auto" }}
    >
      {fetching ? (
        <BoxLoader style={{ height: "100%" }} />
      ) : (
        <>
          <div className="d-flex justify-content-between">
            <div
              className="p-4 d-flex align-items-center w-75"
              style={{ gap: "3%" }}
            >
              <div>
                <img src={Regularize} alt="calendar-clock" />
              </div>
              <div>
                <p className="m-0" style={{ color: "#7c8db0" }}>
                  MY SPACE
                </p>
                <p
                  className="m-0"
                  style={{ fontSize: "14px", fontWeight: 600 }}
                >
                  Attendance Time Update Request
                </p>
              </div>
            </div>
          </div>
          <hr className="m-0"></hr>

          {data?.length > 0 ? (
            data?.map((el: any) => {
              return (
                <div>
                  <div
                    className="d-flex align-items-center pt-3 pb-1 pl-3 pr-3"
                    style={{ gap: "3%" }}
                  >
                    <div>
                      <CustomizedAvatar
                        name={`${el?.user_id?.first_name} ${
                          el?.user_id?.last_name ? el?.user_id?.last_name : ""
                        }`}
                        image={el?.user_id?.profile_pic?.file_url}
                        style={{ width: "58px", fontSize: "21px" }}
                      />
                    </div>
                    <div>
                      <p
                        className="mb-1"
                        style={{
                          fontSize: "15px",
                          fontWeight: 500,
                          cursor: "pointer",
                        }}
                      >
                        {`${el?.user_id?.first_name} ${
                          el?.user_id?.last_name ? el?.user_id?.last_name : ""
                        }`}{" "}
                        - {el?.regularize?.new_start_time || el?.start_time} to{" "}
                        {el?.regularize?.new_end_time || el?.end_time}.
                      </p>
                      <p
                        className="mb-1"
                        style={{
                          fontSize: "15px",
                          fontWeight: 500,
                          cursor: "pointer",
                          color: "#6e7491",
                        }}
                      >
                        Previous Time Logged - {el?.start_time} to{" "}
                        {el?.end_time}
                      </p>
                    </div>
                  </div>
                  <div
                    className="mt-1 d-flex pt-0 pb-3 pl-3 pr-3"
                    style={{ gap: "3%" }}
                  >
                    <div
                      style={{
                        width: "58px",
                        height: "10px",
                      }}
                    ></div>
                    <div
                      style={{ cursor: "pointer", height: "fit-content" }}
                      onClick={() => {
                        handleFeedBackModal(el);
                      }}
                    >
                      <img src={ApprovedIcon} alt="approved-icon" />
                      <span
                        className="ml-2"
                        style={{
                          color: "#dd4433",
                          fontSize: "16px",
                          fontWeight: 500,

                          cursor: "pointer",
                        }}
                      >
                        Approve
                      </span>
                    </div>
                    <div
                      style={{ height: "fit-content", cursor: "pointer" }}
                      onClick={() => {
                        // handleReject();
                        handleFeedBackModal(el);
                        // setApprovalId(el?._id);
                      }}
                    >
                      <img src={RejectIcon} alt="reject-icon" />
                      <span className="ml-2">Reject</span>
                    </div>
                  </div>
                  <hr style={{ marginTop: 0 }}></hr>
                </div>
              );
            })
          ) : (
            <div
              style={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                height: "70%",
                flexDirection: "column",
              }}
            >
              <img src={LikeIcon} alt="like-icon" />
              <div
                className="mt-3"
                style={{
                  fontSize: "19px",
                  fontWeight: 600,
                  textAlign: "center",
                }}
              >
                No Data Found!
              </div>
            </div>
          )}
        </>
      )}
    </div>
  );
};

export default RegularizeApproveAndReject;
